module.exports = __webpack_public_path__ + "img/map_on.066f2275.png";